module.exports = __webpack_public_path__ + "static/img/main.5ed17c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/main.jpg
// module id = fbeq
// module chunks = 2